import Crud from '../views/Pedido/Crud'
import BaixaEstoque from '../views/Pedido/BaixaEstoque'
import Entity from '../views/Pedido/Add'
import View from '../views/Pedido/View'
import Approve from '../views/Pedido/Approve'
import Redispensar from '../views/Pedido/Redispensar'
import Semanal from '../views/Pedido/Semanal'
import Suplementar from '../views/Pedido/Suplementar'
import Rapido from '../views/Pedido/Rapido'

let routes = {
    path: '/pedidos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/pedidos/add',
            name: 'NewPedido',
            component: Entity,
            meta: {
                pageTitle: 'Lista de Pedidos',
                breadcrumb: [
                    {
                        text: 'Pedidos',
                        active: false,
                        to: '/pedidos',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/pedidos/suplementar',
            name: 'NewPedido',
            component: Suplementar,
            meta: {
                pageTitle: 'Lista de Pedidos',
                breadcrumb: [
                    {
                        text: 'Pedidos',
                        active: false,
                        to: '/pedidos/suplementar',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/pedidos/rapido',
            name: 'NewPedido',
            component: Rapido,
            meta: {
                pageTitle: 'Lista de Pedidos',
                breadcrumb: [
                    {
                        text: 'Pedidos',
                        active: false,
                        to: '/pedidos/rapido',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/pedidos/atender/:id?',
            name: 'approvePedido',
            component: Approve,
            meta: {
                pageTitle: 'Pedidos',
                breadcrumb: [
                    {
                        text: 'Pedidos',
                        active: false,
                        to: '/pedidos',
                    },
                    {
                        text: 'Atender',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/pedidos/redispensar/:id?',
            name: 'redispensarPedido',
            component: Redispensar,
            meta: {
                pageTitle: 'Pedidos',
                breadcrumb: [
                    {
                        text: 'Pedidos',
                        active: false,
                        to: '/pedidos',
                    },
                    {
                        text: 'Redispensar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/pedidos/view/:id?',
            name: 'viewPedido',
            component: View,
            meta: {
                pageTitle: 'Pedidos',
                breadcrumb: [
                    {
                        text: 'Pedidos',
                        active: false,
                        to: '/pedidos',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/pedidos',
            name: 'list-pedidos',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Pedidos',
                breadcrumb: [
                    {
                        text: 'Pedidos',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/pedidos-baixa-estoque',
            name: 'list-pedidos-baixa-estoque',
            component: BaixaEstoque,
            meta: {
                pageTitle: 'Lista de Pedidos',
                breadcrumb: [
                    {
                        text: 'Pedidos',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/semanal',
            name: 'pedido-semanal',
            component: Semanal,
            meta: {
                pageTitle: 'Pedido Semanal',
                breadcrumb: [
                    {
                        text: 'Pedido Semanal',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
